import {
  AnalysisResultType,
  DatasetAnalysisPayload,
  OutputGrid
} from "@/types/dataset";
import { ScoringOptions } from "@/types/spatial";
import { CustomError } from "@/utils/errors";

type RunSpatialAnalysisAction = {
  dataset_count: number;
  output_type:
    | AnalysisResultType.TYPE_SITE_PROFILING
    | AnalysisResultType.TYPE_GRID;
  scoring_option: ScoringOptions;
  grid_type?: string;
  grid_level?: number;
  error?: CustomError;
};
export const buildSpatialAnalysisTracker = (
  data: DatasetAnalysisPayload & { error?: CustomError }
) => {
  const trackedData: RunSpatialAnalysisAction = {
    dataset_count: data.datasets.length,
    output_type: data.output?.output_type,
    scoring_option: data.output?.scoring_option,
    error: data?.error
  };
  if ((data.output as OutputGrid)?.grid_config) {
    trackedData.grid_type = (data.output as OutputGrid)?.grid_config?.grid_type;
    trackedData.grid_level = (data.output as OutputGrid)?.grid_config?.level;
  }
  return trackedData;
};
